module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/preViewMedia/assets/backBtnToSmall.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/preViewMedia/assets/backBtnToSmall.png
// module id = 1813
// module chunks = 418